var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camsContainer"},[_c('ContentHeader',{attrs:{"name":"Dashboard","subHeader":_vm.subHeader}}),_c('div',{staticClass:"widget-container"},_vm._l((_vm.widgets),function(widget){return _c('Widget',{key:widget.title,staticClass:"widget",attrs:{"widget":widget}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }